module.exports = __webpack_public_path__ + "img/sports_retail.36bf286e.png";